import React from 'react'

export const PrivateFooter = () => {
    return (
        <>
            <div className="col-md-12">
                <div className="copyrights">© 2021 gamarreando. All Rights Reserved.</div>
            </div>
        </>
    )
}